import {
  EAttendeeInformation,
  EDefaultAttendeeName,
} from '@app/core/models/api';
import {
  mapPassportBeaconGroups,
  mapVerificationTiers,
  PassportBeaconGroup,
  VerificationTier,
} from '@app/core/models/btr-event.model';
import { BtrPassportModel } from '@app/core/models/btr-passport.model';
import { ITicketApiModel } from './api/ticket.api.model';

export interface IBundleTicket {
  id: string;
  title: string;
  description: string;
  cost: number;
  is_fee_on_consumer: boolean;
  c_tickets_purchased: number;
  c_tickets: number;
  c_tickets_per_person?: number;
  c_tickets_per_person_at_once: number;
  available_until?: string;
  start: string;
  end: string;
  count: number;
}

export class TicketModel {
  id: string;
  event: string;
  title: string;
  description: string;
  cost: number;
  nTickets: number;
  nTicketsPerPerson: number;
  nTicketsPerPersonAtOnce: number;
  nTicketsPurchased: number;
  nVerified: number;
  nNotVerified: number;
  nVerifiers: number;
  nAttendees: number;
  verifiers: number;
  attendees: number;
  availableUntil: Date;
  isDeleted: boolean;
  statuses: ITicketApiModel['statuses'];
  start: string;
  end: string;
  isFeeOnConsumer: boolean;
  bundle?: Array<IBundleTicket>;
  ticketCountInBundle?: number;
  isBundleInfoShown?: boolean;
  isPassport?: boolean;
  verifications?: Array<{ date: string; beacon_id: number }>;

  cRewards?: number;
  isSelfCheckIn?: boolean;
  cBeaconsToVerify?: number;

  passportCompletionEmailMessage?: string;
  rewardHowToGet?: string;
  rewardInfo?: string;
  passportBeaconIds: Array<number>;
  passportBeaconGroups: Array<PassportBeaconGroup>;
  verificationTiers: Array<VerificationTier>;
  cVerified?: number;

  lastPurchaseEmail?: string;

  constructor(source: ITicketApiModel) {
    this.id = source.id;
    this.event = source.event;
    this.title = source.title;
    this.description = source.description;
    this.cost = source.cost;
    this.nTickets = source.c_tickets;
    this.nTicketsPerPerson = source.c_tickets_per_person;
    this.nTicketsPerPersonAtOnce = source.c_tickets_per_person_at_once;
    this.nTicketsPurchased = source.c_tickets_issued;
    this.nVerified = source.c_verified;
    this.nNotVerified = source.c_not_verified;
    this.nVerifiers = source.c_verifiers;
    this.nAttendees = source.c_attendees;
    this.verifiers = source.verifiers;
    this.attendees = source.attendees;
    this.availableUntil = source.available_until;
    this.isDeleted = source.is_deleted;
    this.statuses = source.statuses;
    this.start = source.start;
    this.end = source.end;
    this.isFeeOnConsumer = source.is_fee_on_consumer;
    this.bundle = source.bundle;
    if (this.bundle) {
      let count = 0;
      for (const bundle of this.bundle) {
        count += bundle.count;
      }
      this.ticketCountInBundle = count;
      this.isBundleInfoShown = false;
    }
    this.isPassport = source.is_passport;
    this.cRewards = source.c_rewards;
    this.isSelfCheckIn = source.is_self_checkin;
    this.cBeaconsToVerify =
      source.c_beacons_to_verify ?? source.passport_beacon_ids?.length;

    this.passportCompletionEmailMessage =
      source.passport_completion_email_message;
    this.rewardHowToGet = source.reward_how_to_get;
    this.rewardInfo = source.reward_info;
    this.passportBeaconIds = source.passport_beacon_ids;
    this.passportBeaconGroups = mapPassportBeaconGroups(
      source.passport_beacon_groups,
    );
    this.verificationTiers = mapVerificationTiers(source.verification_tiers);
    this.cVerified = source.c_verified;
    if (this.statuses?.length > 0) {
      this.statuses[0].info?.forEach(info => {
        if (info.name === EDefaultAttendeeName.EMAIL) {
          this.lastPurchaseEmail = info.value;
        }
      });
    }
  }
}

export enum EYourOrderType {
  ACTIVE = 'ACTIVE',
  PAST = 'PAST',
}

export interface IYourPassportItem {
  passport: BtrPassportModel;
  tickets: Array<TicketModel>;
}
